<template>
  <div class="checkbox-wrapper">
    <v-checkbox
      v-model="selectedValue"
      :label="disableLabelClick ? '' : label"
      :value="checkBoxValue"
      :rules="computedRules"
      :disabled="disabled"
      :hide-details="hideDetails || simple"
      :class="`${noteRequiredField ? 'required-field': ''}
        ${simple ? 'simple-checkbox': ''}
        ${stack ? 'stack-checkbox': ''}
        ${disableLabelClick ? 'no-label-checkbox disable-min-width' : ''}`"
      :ripple="false"
      @change="$emit('change', !!selectedValue); $emit('input', !!selectedValue)"
      @click="$emit('click', $event)"
    >
      {{ selectedValue }}
      <template
        v-if="!disableLabelClick"
        #label
      >
        <div
          v-if="noteRequiredField"
        >
          <strong
            v-if="!disabled"
            class="error--text"
          >*&nbsp;</strong>
        </div>
        <input-history
          :title="label"
          :value="previousValue"
          :dos="previousValueDos"
        >
        </input-history>
        {{ label }}
      </template>
    </v-checkbox>
    <div
      v-if="disableLabelClick"
      class="non-clickable-label"
      @click.stop.prevent
    >
      <div
        v-if="noteRequiredField"
        class="required-indicator"
      >
        <strong
          v-if="!disabled"
          class="error--text"
        >*&nbsp;</strong>
      </div>
      <input-history
        :title="label"
        :value="previousValue"
        :dos="previousValueDos"
      >
      </input-history>
      <span class="label-text">{{ label }}</span>
    </div>
  </div>
</template>

<script>
import InputHistory from '@/components/elements/InputHistory.vue'

export default {
  components: {
    InputHistory
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    simple: {
      type: Boolean,
      default: false,
    },
    stack: {
      type: Boolean,
      default: false,
    },
    previousValue: {
      type: [String, Boolean, Number],
      default: null,
    },
    previousValueDos: {
      type: String,
      default: null,
    },
    disableLabelClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedValue: this.value,
      checkBoxValue: true,
    }
  },
  computed: {
    noteRequiredField() {
      return !this.disabled && this.required && !this.selectedValue
    },
    computedRules() {
      return (this.required && !this.disabled) ? this.$validationRules.required : []
    },
  },
  watch: {
    value() {
      this.selectedValue = this.value
    },
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style lang="scss">
.checkbox-wrapper {
  display: flex;
  align-items: flex-start;

  .v-input.v-input--checkbox {
    &.no-label-checkbox {
      flex: 0 0 auto;
      width: auto !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;

      .v-input__control {
        min-height: auto !important;

        .v-input__slot {
          margin-bottom: 0 !important;
          margin-right: 0 !important;
        }
      }

      &.simple-checkbox {
        .v-messages {
          display: none;
        }
      }
    }

    &.simple-checkbox {
      margin: 0 !important;
      padding: 0 8px !important;
      .v-input__control {
        margin-bottom: 0px !important;
        .primary--text {
          color: var(--v-secondary-base) !important;
          caret-color: var(--v-secondary-base) !important;
        }
      }
    }

    &.stack-checkbox {
      .v-input__slot {
        display: inline-block;
        text-align: center;
        .v-label {
          top: -6px;
          font-size: 15px;
          white-space: nowrap;
          display: block;
        }
      }

      &.no-label-checkbox {
        & + .non-clickable-label {
          padding-left: 4px;
          padding-top: 0;
          display: block;
          text-align: center;
          margin-top: -6px;

          .label-text {
            font-size: 15px;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .non-clickable-label {
    display: inline-flex;
    align-items: center;
    padding-left: 4px;
    padding-top: 11px;
    cursor: default;
    user-select: none;
    flex: 1;

    .required-indicator {
      display: inline-flex;
      margin-right: 2px;
    }

    .label-text {
      font-size: 16px;
      color: var(--v-secondary-base) !important;
      caret-color: var(--v-secondary-base) !important;
    }

    pointer-events: none;

    > * {
      pointer-events: auto;
      cursor: default;
    }
  }
}

.v-input.v-input--checkbox.no-label-checkbox {
  .v-input__control {
    .v-input__slot {
      .v-input--selection-controls__input {
        margin-right: 0 !important;
      }
    }
  }
}
.v-input.v-input--checkbox.disable-min-width .v-input__slot {
  min-width: 0 !important;
}
</style>
